import React, { Component } from 'react';
//Checked
export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Does the patient have a medical condition such as Gastroesophageal Reflux Disease, which requires an added rice or other non-standard infant formula?</p>
				<div className="toggle">
					<div className={this.props.data.NonFuncSmallBowel === true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('NonFuncSmallBowel', true); }}>Yes</div>
					<div className={this.props.data.NonFuncSmallBowel === false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.props.setData('NonFuncSmallBowel', false); }}>No</div>
				</div>
				<div className="button" onClick={() => this.props.navigate(this.props.data.NonFuncSmallBowel === false ? 'R7' : this.props.data.EnteredDiagnosisCode ? 'R8' : 'R6')}>Continue</div>
			</div>
		);
	}
}